export interface AgentDto {
  AgentId: Guid;
  AgentName: string;
}

export class AgentDto implements AgentDto {
  AgentId = "";
  AgentName = "";
}